import Utils from 'common/Utils';
import bridge from 'common/bridge';
import {getQuizURL} from "../../../../common/quiz_utills";
import _ from 'lodash'

const COMMON_DROPDOWN_PRIMARY_NAV = [
    { name: 'Edit Profile', href: '/user/manage', icon: 'profile', type: 'profileNavItem', no_hover: true },
];

const SIGNOUT_DROPDOWN_NAV = [
    { separate_line: true },
];

const isImpersonate = _.result(bridge, 'session.admin_impersonate_enabled', false);
if (!isImpersonate) {
    SIGNOUT_DROPDOWN_NAV.push({ name: 'Sign out', href: '/auth/logout', icon: 'logout', type: 'logout' })
} else {
    SIGNOUT_DROPDOWN_NAV.push({ name: 'Exit Impersonate', href: '/j_spring_security_exit_user', icon: 'logout' })
}

const ADMIN_PRIMARY_NAV = {
    left: [
        { name: 'Users', href: '/admin/manageUsers', icon: 'students' },
        { name: 'Passages', href: '/editing/manageQuizzes', icon: 'quiz' },
        { name: 'Progress Levels', href: '/progressLevel/listProgressLevels', icon: 'report' },
        { name: 'Coppa Suffixes', href: '/app/admin/coppa/list', icon: 'response' }
    ],
    dropdown: [
        ...COMMON_DROPDOWN_PRIMARY_NAV,
        ...SIGNOUT_DROPDOWN_NAV
    ],
};

const reportUrl = Utils.isNewReportUIVisible() ? '/app/teacher/reports' : '/teaching/studentReport';
const TEACHER_PRIMARY_NAV = {
    left: [
        { name: 'My classes', href: '/app/teacher/class/list', icon: 'classes' },
        { name: 'Progress reports', href: reportUrl, icon: 'report' },
        { name: 'My students', href: '/app/teacher/student/list', icon: 'students' },
        { name: 'Written responses', href: '/teaching/listUnscoredEssayQuestions', icon: 'response' },
        { name: 'Activities', href: '/app/teacher/activities', icon: 'check-green' },
        // {name: 'Reading challenge', href: '/app/teacher/monthlyReport', icon: 'reading-challenge'}
    ],
    dropdown: [
        ...COMMON_DROPDOWN_PRIMARY_NAV,
        { name: "Community", href: 'https://readtheory-community.circle.so/c/start-here/', icon: 'community', no_hover: true },
        { name: "Resources Hub", href: 'https://readtheory.org/resources-hub/', icon: 'resources-hub', no_hover: true },
        { name: "Teacher’s Lounge", href: 'https://readtheory.org/teachers-lounge/', icon: 'glasses', no_hover: true },
        { name: "Printable Assessments", href: '/teaching/listWorksheets', icon: 'print-assesment', no_hover: true },
        ...SIGNOUT_DROPDOWN_NAV
    ]
};

const progressUrl = Utils.isNewReportUIVisible() ? '/app/student/report' : '/dashboard/index';
const STUDENT_PRIMARY_NAV = {
    left: [
        { name: 'Next quiz', href: getQuizURL(true), icon: 'quiz' },
        { name: 'My progress', href: progressUrl, icon: 'progress' },
        { name: 'My writing', href: '/dashboard/reviewShortEssays', icon: 'writing' }
    ],
    dropdown: [
        ...COMMON_DROPDOWN_PRIMARY_NAV,
        { name: 'My teachers', href: '/reading/myTeachers', icon: 'glasses', type: 'myTeachersNavItem' },
        ...SIGNOUT_DROPDOWN_NAV
    ]
};

export const NAVIGATION = {
    admin: ADMIN_PRIMARY_NAV,
    teacher: TEACHER_PRIMARY_NAV,
    student: STUDENT_PRIMARY_NAV
};
